import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useExtendedMutation from '../../hooks/useExtendedMutation';
import {
    ALL_AUCTIONS_QUERY_NAME,
    AUCTION_DETAIL,
    DISTRIBUTE_VOLUME,
} from '../../graphql/auctions';
import { auctionType as auctionTypeRef } from '../../types';
import {
    CANCELLED,
    getUIPhase,
} from '../../utils/AuctionPhase';
import MutationButton from '../buttons/MutationButton';
import DistributeVolumeModal from './DistributeVolumeModal';
import { getPublicConfig } from '../../reducers';
import { isAmprCustomer } from '../../utils/customer';

AuctionDistributeVolumeButton.propTypes = {
    auction: auctionTypeRef.isRequired,
    step: PropTypes.number,
    disabled: PropTypes.bool,
};

function AuctionDistributeVolumeButton(props) {
    const {
        auction,
        step,
        disabled = false,
    } = props;
    const { t } = useTranslation();
    const { customer } = useSelector(getPublicConfig);
    const uiPhase = getUIPhase(auction.phase);
    const distributeVolumeMutation = useExtendedMutation(DISTRIBUTE_VOLUME, {
        variables: { cancelledAuctionId: auction.id },
        successMessageOptions: { key: 'auctions.notification.auction-distribute-success', dataProperty: 'distributeVolume' },
        failureMessageOptions: { key: 'auctions.notification.auction-distribute-failure', params: { name: auction.name } },
        refetchQueries: [ALL_AUCTIONS_QUERY_NAME, {
            query: AUCTION_DETAIL,
            variables: {
                auctionId: auction.id,
            },
        }],
    });
    const variablesComponent = (setVariables, setValid, setFullScreen) => (
        <DistributeVolumeModal
            cancelledAuction={auction}
            step={step}
            setVariables={setVariables}
            setValid={setValid}
            setFullScreen={setFullScreen}
        />
    );
    // Offered by default and locked only where it is not contracted, so the general
    // configuration exposes the feature and a specific customer opts out.
    const isDistributable = !isAmprCustomer(customer) && uiPhase.is(CANCELLED) && !auction.volumeDistributed;
    return (
        isDistributable && (
            <MutationButton
                className="distribute-volume-auction button-bordered-orange button"
                confirmationMessage={t('auctions.confirm-distribute-volume', { name: auction.name })}
                variablesHeadline={t('auctions.distribute-volume.title', { name: auction.name })}
                extendedMutation={distributeVolumeMutation}
                disabled={disabled}
                variablesComp={variablesComponent}
            >
                <FontAwesomeIcon icon="share-square" />&nbsp;{t('auctions.distribute-volume.button')}
            </MutationButton>
        )
    );
}

export default AuctionDistributeVolumeButton;
